import { render, staticRenderFns } from "./PatrollingRecord.vue?vue&type=template&id=4ce48cfc&scoped=true"
import script from "./PatrollingRecord.vue?vue&type=script&lang=js"
export * from "./PatrollingRecord.vue?vue&type=script&lang=js"
import style0 from "./PatrollingRecord.vue?vue&type=style&index=0&id=4ce48cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce48cfc",
  null
  
)

export default component.exports